import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaClock, FaDollarSign, FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./tourdetails.css";
import { Helmet } from "react-helmet";

const TourDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tour, setTour] = useState(null);
  const [showItinerary, setShowItinerary] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  const [mainImage, setMainImage] = useState(null);

  useEffect(() => {
    fetch(`https://admin.mythsegypttours.com/api/tours/${id}`)
      .then((res) => res.json())
      .then((result) => {
        setTour(result.data);

        // تعيين أول صورة كـ mainImage
        if (result.data?.images?.length) {
          setMainImage(
            `https://admin.mythsegypttours.com/storage/${result.data.images[0]}`
          );
        }
      })
      .catch((err) => console.error("Error fetching tour:", err));
  }, [id]);

  // تثبيت الكارت في الموبايل
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 768) {
        const section = document.querySelector(".imageGallery");
        if (section) {
          const sectionBottom = section.getBoundingClientRect().bottom;
          setIsFixed(sectionBottom <= 0);
        }
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!tour) return <p>Loading...</p>;
<Helmet>
  <title>{tour.title} | Myths Egypt Tours</title>
  <meta
    name="description"
    content={`Book ${tour.title} with Myths Egypt Tours. ${tour.short_description || "Explore Egypt’s wonders with professional guides."}`}
  />
  <meta property="og:title" content={`${tour.title} | Myths Egypt Tours`} />
  <meta
    property="og:description"
    content={`Discover ${tour.title} and many other unforgettable experiences in Egypt.`}
  />
  <meta property="og:url" content={`https://mythsegypttours.com/tour-details/${tour.id}`} />
  <meta property="og:image" content={mainImage} />
</Helmet>

  return (
    
    <section className="tourDetails container">
      <div className="headerRow">
        <h1 className="tourTitle">{tour.title}</h1>
        <div className="tourPrice">
          Start From{" "}
          <span>
            {tour.pricings?.length > 0
              ? `$${Math.min(...tour.pricings.map((p) => parseFloat(p.price_per_person)))}`
              : "N/A"}
          </span>
        </div>
      </div>

      {/* الصور */}
      <div className="imageGallery">
        <div className="mainImage">
          <img src={mainImage} alt={tour.title} />
          <div className="tourMeta">
            <span className="duration_number">
              
{tour.pricings?.length > 0
              ? `$${Math.min(...tour.pricings.map((p) => parseFloat(p.price_per_person)))}`
              : "N/A"}            </span>
            <div className="duration_wrapper">
  <span className="duration_icon">
    <FaClock />
  </span>
  <span className="duration_number">
    {tour.duration_id || "N/A"}
  </span>
</div>

          </div>
        </div>

        <div className="sideImages">
  {Array.isArray(tour.images) && tour.images.length > 0 ? (
    tour.images
      .filter(
        (img) =>
          `https://admin.mythsegypttours.com/storage/${img}` !==
          mainImage
      )
      .map((img, idx) => (
        <img
          key={idx}
          src={`https://admin.mythsegypttours.com/storage/${img}`}
          alt={`image-${idx}`}
          onClick={() =>
            setMainImage(
              `https://admin.mythsegypttours.com/storage/${img}`
            )
          }
          style={{ cursor: "pointer" }}
        />
      ))
  ) : (
    <p>No images available.</p>
  )}

          {/* كارت الحجز */}
          <div className={`bookingCard ${isFixed ? "fixed" : ""}`}>
            <button
              className="bookBtn"
              onClick={() =>
                navigate(`/booking`, {
                  state: {
                    tourId: tour.id,
                    tourTitle: tour.title,
                    pricings: tour.pricings, // نبعت كل الأسعار
                    images: tour.images, // ✅ أضفنا الصور هنا
                    bookingDaysBefore: tour.booking_days_before, // ✅ أرسلها هنا
                  },
                })
              }
            >
              Book & Pay Now
            </button>
            <p>Secure your spot with online payment</p>
          </div>
        </div>
      </div>

      {/* الوصف */}
      <div className="contentRow">
        <div className="leftContent">
          <section>
            <h2>Description</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.description }} />
          </section>

          <section>
            <h2>Inclusions</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.includes }} />
          </section>

          <section>
            <h2>Exclusions</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.exclusions }} />
          </section>

          <section className="accordion">
            <h2 onClick={() => setShowItinerary(!showItinerary)}>
              Tour Itinerary {showItinerary ? <FaChevronUp /> : <FaChevronDown />}
            </h2>
            {showItinerary && (
              <div
                className="accordionContent"
                dangerouslySetInnerHTML={{ __html: tour.tour_itinerary }}
              />
            )}
          </section>

          <section>
            <h2>Children Policy</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.children_policy }} />
          </section>

          <section>
            <h2>Tour Notes</h2>
            <div dangerouslySetInnerHTML={{ __html: tour.tour_notes }} />
          </section>

          {/* الأسعار حسب الجروب */}
          <section className="priceCards">
            {tour.pricings?.map((gp) => (
              <div key={gp.id} className="priceCard">
                <h4>
                  {gp.min_persons} - {gp.max_persons} Persons
                </h4>
                <p>
                  {gp.price_per_person} {gp.currency} / Person
                </p>
              </div>
            ))}
          </section>
        </div>
      </div>
    </section>
  );
};

export default TourDetails;
